<template>
  <div class="agenSort-list-main-page">
    <main-header :hasBanner="true" :type="'salesList'"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'salesList'"></list-left>
      <div class="page-right">
        <div class="right-top">
          <el-date-picker v-model="times" type="month" clearable="false" @change="changeTime" placeholder="选择月">
          </el-date-picker>
        </div>

        <el-table stripe :data="tableData" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="companyName"
            label="机构名称"
            width="300"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="residence"
            label="住宅用房（套数）"
          ></el-table-column>

          <el-table-column
            align="centet"
            header-align="center"
            prop="business"
            label="商业用房（套数）"
          >
          </el-table-column>

          <el-table-column
            align="centet"
            header-align="center"
            prop="work"
            label="办公（套数）"
          >
          </el-table-column>

          <el-table-column
            align="centet"
            header-align="center"
            prop="other"
            label="其他（套数）"
          >
          </el-table-column>
        </el-table>

        <el-pagination
          class="bottom-pagination"
          background
          @current-change="handleCurrentChange"
          :current-page="pagingObj.pageNum"
          :page-size="pagingObj.pageSize"
          layout="prev, pager, next, jumper, total "
          :total="total"
        >
        </el-pagination>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { salesList } from "@/assets/api/resources";
import { districtList } from "@/assets/api/common";

export default {
  name: "creditList",
  components: {
    mainHeader,
    mainFooter,
    listLeft,
  },
  data() {
    return {
      tableData: [],
      pagingObj: {
        pageNum: 1,
        pageSize: 10,
        beginTime: "",
        endTime: "",
      },
      total: 0,
      activeName: "",
      options: [],
      times: "",
    };
  },
  computed: {},
  mounted() {
    this.initDate()
    this.getData();
    this.initCity();
  },
  methods: {
    initDate() {
      let date = new Date()  
      this.times = date
      let y = date.getFullYear()
      let m = date.getMonth()
      var first = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      this.pagingObj.beginTime = this.getDate(first)
      this.pagingObj.endTime = this.getDate(lastDay)
    },
    changeTime(time) {
      let first = new Date(time)  
      let y = first.getFullYear()
      let m = first.getMonth();
      var lastDay = new Date(y, m + 1, 0);
      this.pagingObj.beginTime = this.getDate(first)
      this.pagingObj.endTime = this.getDate(lastDay)
      this.getData()
    },
    getDate (date) {
    var nowdate = new Date(date).toLocaleDateString().replace(/\//g, '-')
    return nowdate
    },
    async initCity() {
      const res = await districtList();
      this.options = ((res && res.data && res.data.data) || []).map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      this.options.unshift({
        value: null,
        label: "全部",
      });
    },
    goDetail(item) {
      const jumpUrl = this.$router.resolve({
        path: "/company/detail",
        query: { id: item.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    showCode(i) {
      this.$set(this.tableData[i], "showCode", true);
    },
    hideCode(i) {
      this.$set(this.tableData[i], "showCode", false);
    },
    handleCurrentChange(val) {
      this.pagingObj.pageNum = val;
      this.getData();
    },
    async getData() {
      const res = await salesList(this.pagingObj);
      if (res && res.data && res.data.code == 200) {
        this.tableData = res.data.rows || [];
        this.total = res.data.total;
      }
    },
    search() {
      this.pagingObj.pageNum = 1;
      this.getData();
    },
  },
};
</script>

<style lang="less">
.agenSort-list-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    .page-right {
      flex: 1;
      .right-top {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        justify-content: space-between;
        .right-title {
          font-size: 18px;
          color: #222;
        }
        .right-tips {
          margin-top: 20px;
          color: #b1191a;
          font-size: 14px;
        }
        .ad-select {
          width: 203px;
          input {
            height: 50px;
            border-radius: 0;
          }
        }
        .ad-input {
          width: 520px;
          height: 50px;
          border: 1px solid #dcdfe6;
          border-left: 0;
          border-right: 0;
          input {
            height: 100%;
            border: none;
          }
        }
        .search-btn {
          background: #9b2f3d;
          width: 140px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .mg-t20 {
    margin-top: 20px;
  }

  .el-table .cell {
    overflow: initial !important;
  }
  .el-table {
    overflow: initial !important;
  }
  .el-table__body-wrapper {
    overflow: initial !important;
  }
  .qr-box {
    position: relative;
    z-index: 2;
    img {
      position: absolute;
      z-index: 1;
      left: -50px;
      top: 10px;
    }
  }
  .bottom-pagination {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
  }

  .el-tabs__item {
    line-height: 1;
    height: 28px;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item.is-active {
    color: #b1191a;
    &:hover {
      color: #b1191a;
    }
  }
  .el-tabs__item:hover {
    color: #b1191a;
  }
  .el-tabs__active-bar {
    background-color: #b1191a;
  }
}
</style>